export const globalNavId = 'meganav-variant-global-nav';

export const localNavId = 'meganav-variant-local-nav';
